import { ApiClient } from './ApiClient';

export interface ValueCount {
    value: string;
    count: number;
}

export interface EventListingsQueryParams {
    [key: string]: string | number | undefined;
    lang?: string;
    page?: number;
    q?: string;
}
export interface EventListing {
    HeadLine?: string;
    ThumbnailImage?: string;
    ThumbnailImage_AltText?: string;
    Location?: string;
    UpdatedDateTime?: string;
    StartPublish?: string;
    TopPreamble?: string;
    LinkURL?: string;
    EventImage?: string;
    LabelForReadMore?: string;
}

export interface EventListingsPageData {
    eventListings: EventListing[];
    totalPages: number;
    totalEventListings: number;
}

export class EventListingsApi {
    private apiClient: ApiClient;

    constructor() {
        this.apiClient = new ApiClient('/api/eventlistings');
    }

    public getEventListings(params: EventListingsQueryParams = {}): Promise<EventListingsPageData> {
        return this.apiClient.get<EventListingsPageData>('pageData', params);
    }
}

// Export a single shared instance
export const eventListingsApi = new EventListingsApi();